import api from './api'

const fileMannager = {
  addImage(file) {
    return api.post('FileManager/api/File/AddImage', file)
  },
  addFile(file, config) {
    return api.post('FileManager/api/File/AddFiles', file, config)
  },
}

export default fileMannager
